import React, { PropsWithChildren, useEffect, useState } from "react";

import AdvisorContainer from "../AdvisorContainer";
import AdvisorContentContainer from "../AdvisorContentContainer";
import { ClientsFiltersProvider, useClientsFilters } from "../Clients/context";
import ClientsTable from "@src/multiCustodian/components/Advisor/Clients/ClientsTable";
import { ClientType } from "@src/multiCustodian/components/Advisor/Households/constants";
import HouseholdsHeader from "@src/multiCustodian/components/Advisor/Households/HouseholdsHeader";
import HouseholdsTable from "@src/multiCustodian/components/Advisor/Households/HouseholdsTable/HouseholdsTable";

import { getViewFromTab, saveViewToTab } from "./storage";

const HouseholdsContent: React.FC<PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [currentView, setCurrentView] = useState<ClientType>(() =>
    getViewFromTab(ClientType.HOUSEHOLD)
  );

  const { search, searchFilters, setSearch, setSearchFilters } =
    useClientsFilters();

  useEffect(() => {
    saveViewToTab(currentView);
  }, [currentView]);

  return (
    <AdvisorContentContainer heroTitle={"Households"}>
      <HouseholdsHeader
        search={search}
        searchFilters={searchFilters}
        setSearch={setSearch}
        setSearchFilters={setSearchFilters}
        currentView={currentView}
        setCurrentView={setCurrentView}
      />

      {currentView === ClientType.HOUSEHOLD ? (
        <HouseholdsTable search={search} />
      ) : (
        <ClientsTable search={search} searchFilters={searchFilters} />
      )}

      <div>{children}</div>
    </AdvisorContentContainer>
  );
};

const Households: React.FC<PropsWithChildren<unknown>> = ({ children }) => {
  return (
    <AdvisorContainer>
      <ClientsFiltersProvider searchQueryParam="search">
        <HouseholdsContent>{children}</HouseholdsContent>
      </ClientsFiltersProvider>
    </AdvisorContainer>
  );
};

export default Households;
